import _ from 'lodash';
import {
  INITIATING_SMALL_TALK_CLIENT_REQUEST, INITIATING_SMALL_TALK_CLIENT_SUCCEDDED, INITIATING_SMALL_TALK_CLIENT_FAILED,
  INITIATE_SMALL_TALK_SESSION, INVALIDATE_SMALL_TALK_SESSION, RECEIVED_SMALL_TALK_MESSAGE, TOGGLE_SMALL_TALK_WINDOW_VISIBILITY,

  FETCHING_SMALL_TALK_MESSAGES_REQUEST, FETCHING_SMALL_TALK_MESSAGES_SUCCEDDED, FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED
} from '../actions/actionTypes.jsx';

const sessionState = {
  contact: null,
  visible: false,
  messages: {
    loading: false,
    items: []
  }
}

const initialState = {
  initiating: false,
  initiated: false,
  authKey: null,
  uuid: null,
  session: sessionState,
  presence: {}
};

function smallTalkReducer(state = initialState, action) {
  switch (action.type) {
    case INITIATING_SMALL_TALK_CLIENT_REQUEST:
      return {
        ...state,
        initiating: true
      }

    case INITIATING_SMALL_TALK_CLIENT_SUCCEDDED:
      return {
        ...state,
        initiating: false,
        initiated: true,
        authKey: action.payload.authKey,
        uuid: action.payload.uuid
      }

    case INITIATING_SMALL_TALK_CLIENT_FAILED:
      return {
        ...state,
        initiating: false,
        initiated: false,
        error: action.payload
      }

    case INITIATE_SMALL_TALK_SESSION:
      var contact = action.payload;
      var session = state.session;

      if (session.contact === contact) {
        session = {
          ...session,
          visible: true
        }
      } else {
        session = {
          ...session,
          contact: action.payload,
          channel: action.payload.uuid,
          visible: true,
          messages: {
            loading: false,
            items: []
          }
        }
      }

      return {
        ...state,
        session: session
      }

    case INVALIDATE_SMALL_TALK_SESSION:
      return {
        ...state,
        session: {
          contact: null,
          messages: {
            loading: false,
            items: []
          }
        }
      }

    case TOGGLE_SMALL_TALK_WINDOW_VISIBILITY:
      var { contact, visible } = action.payload;

      return {
        ...state,
        session: {
          ...state.session,
          visible: visible
        }
      }

    case RECEIVED_SMALL_TALK_MESSAGE:
      var { channel, message } = action.payload;

      var index = _.findIndex(state.session.channel, (item) => { 
        console.log(item);
        return item == channel 
      });

      if (index < 0) {
        return state;
      }

      var messages = [...state.session.messages.items, message];
      _.sortBy(messages, 'timestamp');

      return {
        ...state,
        session: {
          ...state.session,
          messages: {
            ...state.session.messages,
            items: messages
          }
        }
      }

    case FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED:
      var { response } = action.payload;
      console.log(action.payload);

      return {
        ...state,
        presence: {
          ...state.presence,
          ...response
        }
      }

    case FETCHING_SMALL_TALK_MESSAGES_REQUEST:
      return {
        ...state,
        session: {
          ...state.session,
          messages: {
            ...state.session.messages,
            loading: true
          }
        }
      }

    case FETCHING_SMALL_TALK_MESSAGES_SUCCEDDED:

      var messages = action.payload.response || [];
      messages = messages.map(item => {
        return {
          ...item.message,
          timestamp: item.timetoken
        }
      })

      _.sortBy(messages, 'timestamp');

      return {
        ...state,
        session: {
          ...state.session,
          messages: {
            ...state.session.messages,
            loading: false,
            items: messages
          }
        }
      }

    default:
      return state
  }
}

export { smallTalkReducer };